import React, { useEffect, useState } from "react";
import { Button, Container, Header, Loader } from "semantic-ui-react";
import "./List.scss";
import TopNavigation from "../global_components/TopNavigation";
import { Segment } from "semantic-ui-react";
import { useHistory, useParams } from "react-router-dom";
import { useReportsFetch } from "../../hooks/useReportsFetch";
import products from "../../constants/products";
import { useSelector } from "react-redux";
import identitySelectors from "../../selectors/identity";
import { ReportsCard } from "../global_components/legacy_reports/ReportsCard";

export type Report = {
  reportscheduleId: number | null;
  emailFrequency: number | null;
  emailDay: number | null;
  personId: number;
  classificationId: number;
  departmentId: number;
  reportId: number;
  reportType: number;
  objectType: number;
  reportName: string;
  description: string;
};

const CrmReportsList = () => {
  const params = useParams<{ site: string }>();
  const user = useSelector(identitySelectors.getUser);

  const crmReportsQuery = useReportsFetch(products.CRM);
  const crmReports = crmReportsQuery.reportsList?.crmReports;

  const [categorizedReports, setCategorizedReports] = useState<{
    customRequests: Report[];
    internalRequests: Report[];
    externalRequests: Report[];
    detailedRequests: Report[];
  }>({ customRequests: [], internalRequests: [], externalRequests: [], detailedRequests: [] });

  // Categorize reports when the query finishes loading
  useEffect(() => {
    if (!crmReportsQuery.isLoading && crmReports) {
      const categorized = categorizeReports(crmReports, Number(user.id));
      setCategorizedReports(categorized);
    }
  }, [crmReportsQuery.isLoading, crmReports, user.id]);
  const history = useHistory();

  return (
    <>
      <TopNavigation
        tabs={[
          { to: "/crm/list", label: "Requests", activeWhenURLIncludes: "/crm/list" },
          { to: "/crm/reports", label: "Reports", activeWhenURLIncludes: "/crm/reports" },
        ]}
      />
      <Segment className='titleCard tw-mx-4 tw-my-[8px]'>
        <div className='tw-flex tw-items-center tw-justify-between'>
          <Header as='h1' className='tw-mb-0'>
            Reports
          </Header>

          <Button secondary onClick={() => history.push(`/${params.site}/crm/reports/new`)}>
            Create
          </Button>
        </div>
      </Segment>

      {crmReportsQuery.isLoading && (
        <Container className='tw-flex tw-h-full tw-items-center tw-justify-center'>
          <Loader active>Loading...</Loader>
        </Container>
      )}
      {!crmReportsQuery.isLoading && categorizedReports?.customRequests?.length > 0 && (
        <ReportsCard
          title='Your Request Reports'
          reports={categorizedReports.customRequests}
          canDelete={true}
          product={products.CRM}
        ></ReportsCard>
      )}
      {!crmReportsQuery.isLoading && categorizedReports?.externalRequests?.length > 0 && (
        <ReportsCard
          title='External Request Reports'
          reports={categorizedReports.externalRequests}
          product={products.CRM}
        ></ReportsCard>
      )}
      {!crmReportsQuery.isLoading && categorizedReports?.internalRequests?.length > 0 && (
        <ReportsCard
          title='Internal Request Reports'
          reports={categorizedReports.internalRequests}
          product={products.CRM}
        ></ReportsCard>
      )}
      {!crmReportsQuery.isLoading && categorizedReports?.detailedRequests?.length > 0 && (
        <ReportsCard
          title='Detailed Request Reports'
          reports={categorizedReports.detailedRequests}
          product={products.CRM}
        ></ReportsCard>
      )}
    </>
  );
};

export default CrmReportsList;

//Split the CRM reports into 4 categories - custom reports, detailed reports, internal reports, and external reports
const categorizeReports = (allReports: Report[] | undefined, currentUserId: number) => {
  // Initialize the categorized object
  const reportCategories: {
    customRequests: Report[];
    internalRequests: Report[];
    externalRequests: Report[];
    detailedRequests: Report[];
  } = {
    customRequests: [],
    internalRequests: [],
    externalRequests: [],
    detailedRequests: [],
  };

  allReports?.forEach((report) => {
    if (report.personId === currentUserId && report.departmentId === 0 && report.classificationId === 0) {
      // Memorized report
      reportCategories.customRequests.push(report);
    } else if (report.reportType === 1) {
      reportCategories.detailedRequests.push(report);
    } else if (report.objectType === 0) {
      reportCategories.externalRequests.push(report);
    } else {
      // Internal summary report
      reportCategories.internalRequests.push(report);
    }
  });

  return reportCategories;
};
